<button
  type="button"
  class="eventq-lined-tab"
  [class.eventq-lined-tab--active]="active()"
  (click)="selected.emit()"
>
  <span class="eventq-lined-tab__label">{{ label() }}</span>
  @if (showCount()) {
    <span class="eventq-lined-tab__chip">{{ count() }}</span>
  }
</button>
